<template>
    <div class="iu-card" :class="shadow ? 'is-' + shadow + '-shadow' : 'is-always-shadow'">
        <div class="iu-card__header" v-if="$slots.header || header">
            <slot name="header">{{ header }}</slot>
        </div>
        <div class="iu-card__body" :style="bodyStyle">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'IuCard',
    props: {
        header: {},
        bodyStyle: {},
        shadow: {
            type: String,
        },
    },
};
</script>

<style scoped>
.iu-card {
    border-radius: 4px;
    border: 1px solid #ebeef5;
    background-color: #fff;
    overflow: hidden;
    color: #303133;
    -webkit-transition: 0.3s;
    transition: 0.3s;
}
.iu-card.is-always-shadow,
.iu-card.is-hover-shadow:focus,
.iu-card.is-hover-shadow:hover {
    -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.iu-card__header {
    padding: 18px 20px;
    border-bottom: 1px solid #ebeef5;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
.iu-card__body {
    padding: 20px;
}
</style>
